<template>
<header>
  <img src="~@/assets/brand.svg" ref="logo">

</header>
</template>

<script>
export default {
  name: 'HeaderNav',
  props: {
    msg: String
  }
}
</script>

<style scoped>
header { box-shadow:0px 0px 15px rgba(0,0,0,.35); min-height: 60px; background-color: #00b589; text-align: center;}  
header img { max-width:180px; margin-top:9px;}
header h2 { color:#fff; font-weight: 700; text-align: center; padding-top:10px; margin:0;}
header h2 span { font-weight: 100;}
header a.menu { width:30px; height: 30px; border:#000 solid 1px; display: inline-block; position: absolute; top:10px; right:15px; text-align: center;}
header a.menu svg { width:30px; height:30px;}

header nav { position: fixed; top:0; bottom: 0; right:0; min-width: 350px; background-color: #fbfbfb; box-shadow:0px 0px 15px rgba(0,0,0,.25); padding-top:60px; display: none;}
header nav a.menu { width:30px; height: 30px; border:#000 solid 1px; display: inline-block; position: absolute; top:10px; right:15px; text-align: center;}
header nav a.link { display: block; border-bottom: #e4e4e4 solid 1px; padding:15px;}
</style>
